import { useCallback, useMemo } from 'react';
import { StandaloneUsageTracker } from '../utils/usageTracker';
export default function useTrackCampaignSelectInteraction({
  applicationId,
  enableTracking,
  handleCampaignAutoSelectChange,
  handleSelectedOptionChange,
  assetObjectType
}) {
  const handleCampaignAutoSelectChangeWithTracking = useCallback(campaignToAutoSelect => {
    if (campaignToAutoSelect) {
      const campaignValue = Array.isArray(campaignToAutoSelect) ? campaignToAutoSelect[0] : campaignToAutoSelect;
      if (campaignValue) {
        StandaloneUsageTracker.track('Campaigns Lib', 'Campaign Select Interaction', {
          action: 'auto select a campaign',
          applicationId,
          campaignId: campaignValue.guid,
          assetId: campaignValue.objectId,
          assetType: assetObjectType
        });
      }
    }
    return handleCampaignAutoSelectChange(campaignToAutoSelect);
  }, [applicationId, handleCampaignAutoSelectChange, assetObjectType]);
  const handleSelectedOptionChangeWithTracking = useCallback(event => {
    const {
      value
    } = event.target;
    if (value) {
      const campaignValue = Array.isArray(value) ? value[0] : value;
      const containsSearchQuery = Array.isArray(value) ? value.some(val => val.containsSearchQuery) : Boolean(value.containsSearchQuery);
      const isRecentlyUsed = Array.isArray(value) ? value.some(val => val.isRecentlyUsed) : Boolean(value.isRecentlyUsed);
      StandaloneUsageTracker.track('Campaigns Lib', 'Campaign Select Interaction', {
        action: 'select a campaign',
        applicationId,
        containsSearchQuery,
        isRecentlyUsed,
        campaignId: campaignValue === null || campaignValue === void 0 ? void 0 : campaignValue.guid,
        assetId: campaignValue === null || campaignValue === void 0 ? void 0 : campaignValue.objectId,
        assetType: assetObjectType
      });
    }
    return handleSelectedOptionChange(event);
  }, [applicationId, handleSelectedOptionChange, assetObjectType]);
  return useMemo(() => {
    if (enableTracking) {
      return {
        handleCampaignAutoSelectChangeWithTracking,
        handleSelectedOptionChangeWithTracking
      };
    }
    return {
      handleCampaignAutoSelectChangeWithTracking: handleCampaignAutoSelectChange,
      handleSelectedOptionChangeWithTracking: handleSelectedOptionChange
    };
  }, [enableTracking, handleCampaignAutoSelectChange, handleCampaignAutoSelectChangeWithTracking, handleSelectedOptionChange, handleSelectedOptionChangeWithTracking]);
}